import * as types from '../mutation-types'

const state = {
  systemName: 'adv',
  reseller: 0, // reseller type, 0 = no, 1=normal, 2=self serve platform reseller(saas)
  hideCost: false,
  simpleCost: false,
  showCoreg: false,
  showPayment: true, // can assign payment way or not
  showCountryStat: false, // show country/nationality stat or not
  showStateStat: true, // show state stat
  filterState: true,
  filterUserType: false,
  filterUserVisitType: false, // default no one can access
  filterTourist: true,
  filterAgeLimit: '18',
  disableFilter: '',
  commonCurrency: 'AUD',
  editCampaignCoreg: true, // enable coreg option
  editCampaign: true,
  selectCountry: true, // can select other country
  zeroLeadCost: false, // can setup 0 as lead cost
  showTermsCond: true, // show terms & conditions
  showSiteCustomerPage: false, // can display site customer stat page
  textMessage: {campaignCost: 'Revenue', source: 'Source', editCampNetwork: 'Network', filterUserType: 'User Type', filterUserVisitType: 'Visitor Type'},
  profileEnable: {company: true, email: true, billing: true},
  systemUrlCountry: 'au',
  enableSurveyModule: false,
  enableReferralModule: false,
  enableEmailPlatform: false,
  currentTimeZone: null, // use timezone setting
  testMode: false
}

const mutations = {
  [types.SET_SYSTEM_NAME] (state, hostname) {
    let commonState
    if (hostname.hostname) {
      commonState = hostname.commonState
      hostname = hostname.hostname
    }
    state.hideCost = false
    state.simpleCost = true
    state.showCoreg = true
    state.disableFilter = ''
    state.filterUserVisitType = false
    state.testMode = false
    if (hostname === 'adv.opentop.com' || hostname === 'advertiser.opentop.com') {
      state.systemName = 'adv'
    } else if (hostname.indexOf('vicinity.') >= 0) {
      state.systemName = 'vicinity'
      state.reseller = 2
      state.simpleCost = true
      state.showCoreg = false
      state.zeroLeadCost = true
      state.selectCountry = false
      state.editCampaignCoreg = false
    } else if (hostname.indexOf('catch.') >= 0) {
      state.systemName = 'catch'
      state.reseller = 2
      state.simpleCost = true
      state.showCoreg = false
      state.disableFilter = 'gender,age'
    } else if (hostname.indexOf('ptt.') >= 0) {
      state.systemName = 'potatohead'
      state.reseller = 2
      state.simpleCost = true
      state.showCoreg = false
      state.showPayment = false
      state.selectCountry = false
      state.textMessage.campaignCost = 'Revenue'
      state.textMessage.source = 'Zone'
      state.textMessage.editCampNetwork = 'Zone'
      state.textMessage.filterUserType = 'Guest Type'
      state.showCountryStat = true
      state.showStateStat = false
      state.filterState = false
      state.filterUserType = true
      state.filterTourist = false
      state.zeroLeadCost = true
      state.showSiteCustomerPage = true
      state.showTermsCond = false
      state.profileEnable = {company: false, email: false, billing: false}
      state.editCampaignCoreg = false
      state.disableFilter = 'gender'
      state.filterAgeLimit = '0'
      state.commonCurrency = 'USD'
      state.enableEmailPlatform = true
    } else if (hostname.indexOf('bac.') >= 0) {
      state.systemName = 'bac'
      state.reseller = 2
      state.simpleCost = true
      state.showCoreg = false
      state.showPayment = false
      state.selectCountry = false
      state.textMessage.campaignCost = 'Revenue'
      state.textMessage.source = 'Zone'
      state.textMessage.editCampNetwork = 'Zone'
      state.textMessage.filterUserType = 'Guest Type'
      state.showCountryStat = true
      state.showStateStat = true
      state.filterState = true
      state.filterUserType = false
      state.filterTourist = true
      state.zeroLeadCost = true
      state.showSiteCustomerPage = true
      state.showTermsCond = false
      state.profileEnable = {company: false, email: false, billing: false}
      state.editCampaignCoreg = false
      state.disableFilter = 'gender,age'
      state.commonCurrency = 'AUD'
      state.currentTimeZone = {'value': 'Australia/Brisbane', 'text': 'Australia/Brisbane (UTC/GMT +10:00)'}
      state.enableEmailPlatform = true
      state.enableSurveyModule = true
    } else if (hostname.indexOf('localhost') >= 0) {
      state.enableSurveyModule = true
      state.enableReferralModule = true
    } else {
      state.systemName = 'adv'
      if (hostname.indexOf('minicards.') >= 0) {
        // state.hideCost = true
        state.simpleCost = true
        // state.editCampaign = false
      }
    }

    if (state.reseller === 2) {
      state.showTermsCond = false
    }

    if (commonState && commonState.testAccount) {
      state.enableSurveyModule = true
      state.enableReferralModule = true
      state.showSiteCustomerPage = true
      state.enableEmailPlatform = true
      state.filterUserVisitType = true
      state.simpleCost = true
      state.hideCost = true
      state.showTermsCond = false
      state.testMode = true
    }
  },
  [types.SET_SYSTEM_URL_COUNTRY] (state, hostname) {
    if (hostname === 'eu-advertiser.opentop.com') {
      state.systemUrlCountry = 'es'
    } else {
      state.systemUrlCountry = 'au'
    }
  },
  [types.SET_SYSTEM_VALUE] (state, value) {
    if (value.hideCost !== undefined) {
      state.hideCost = value.hideCost
    }

    if (value.showCoreg !== undefined) {
      state.showCoreg = value.showCoreg
    }

    if (value.test_account === true) {
      state.enableSurveyModule = true
      state.enableReferralModule = true
      state.showSiteCustomerPage = true
      state.enableEmailPlatform = true
      state.filterUserVisitType = true
      state.simpleCost = true
      state.hideCost = true
      state.showTermsCond = false
      state.testMode = true
    }
  }
}
const actions = {}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/system.js